import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database tables schema:
// - offers (id, name, price, duration, features, active, created_at, updated_at)
// - gallery (id, title, category, image_url, created_at, updated_at)
// - promotions (id, title, description, discount, code, active, created_at, updated_at)
// - site_settings (id, gym_name, phone, email, address, working_hours, social_media, created_at, updated_at)
// - landing_photos (id, title, image_url, created_at, updated_at)
// - hero_video (id, name, video_url, created_at, updated_at)
// - messages (id, name, email, phone, message, read, created_at)
// - admin_credentials (id, username, password, created_at, updated_at)
// - push_notifications (id, user_id, title, message, data, sent_at, created_at)